export function buildGamePath(gameSlug, gameId) {
  if (!gameId) {
    return `/games/${gameSlug}`;
  }

  return `/games/${gameSlug}/${gameId}`;
}
